import { showDialog } from "../../../redux/dialogs/actions";
import { getDynamicTranslation } from "../../core/localization/localizationUtils";

const CertificateAccessDeniedDialogue = () =>
  showDialog(
    {
      title: getDynamicTranslation("dialogues.accessDeniedCertificate.title", "layout"),
      message: (
        <>{getDynamicTranslation("dialogues.accessDeniedCertificate.text", "layout")}</>
      ),
      confirmButtonText: getDynamicTranslation("closeHint", "common"),
    },
    true
  );
export default CertificateAccessDeniedDialogue;
